const inFlight = new Map<string, Promise<unknown>>();

export async function api<T>(path: string, init?: RequestInit): Promise<T> {
  const key = !init || !init.method || init.method === "GET" ? path : "";
  if (key && inFlight.has(key)) return inFlight.get(key) as Promise<T>;
  const request = fetch(path, {
    credentials: "same-origin", ...init,
    headers: init?.body instanceof FormData ? init.headers : { "Content-Type": "application/json", ...init?.headers }
  }).then(async (response) => {
    const body = response.status === 204 ? null : await response.json().catch(() => null);
    if (!response.ok) throw new Error(body?.error || "Something went wrong. Please try again.");
    return body as T;
  }).finally(() => { if (key) inFlight.delete(key); });
  if (key) inFlight.set(key, request);
  return request;
}
